import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Context } from 'components/Store';
import { FormikSearchSelect } from 'components/UiKit/FormikFields';

const LandOwnerName = ({ landOwnerList }) => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);

  return (
    <FormikSearchSelect
      label="Land Owner"
      id="landOwnerName"
      name="landOwnerName"
      items={landOwnerList}
      placeholder="Select Land Owner"
      disabled={!isEnableInfoTabEdit}
    />
  );
};
LandOwnerName.propTypes = {
  landOwnerList: PropTypes.arrayOf(PropTypes.object).isRequired
};
export default LandOwnerName;
